enum FileStatusType {
    AwaitingIngest = "awaiting_ingest",
    Ingesting = "ingesting",
    Processing = "processing",
    Ready = "ready",
    Deleted= "deleted",
    Error = "error"
}

class FileStatusTypeUtil {
    static getLabel(fileStatus: FileStatusType): string {
        switch(fileStatus){
            case FileStatusType.AwaitingIngest:
                return "Waiting For Upload";
            case FileStatusType.Ingesting:
                return "Uploading";
            case FileStatusType.Processing:
                return "Processing";
            case FileStatusType.Ready:
                return "Ready";
            case FileStatusType.Deleted:
                return "Deleted";
            case FileStatusType.Error:
                return "Error";
        }
    }
}

export {FileStatusType, FileStatusTypeUtil}